import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/bulk-booking/page.js");
